import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-blast",
  "use": "icon-blast-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-blast\">\n    <!-- Generator: Sketch 46.2 (44496) - http://www.bohemiancoding.com/sketch -->\n    <title>icon-blast</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"icon-blast_Icons\" stroke=\"none\" stroke-width=\"1\" fill-rule=\"evenodd\">\n        <g id=\"icon-blast_icon-blast\">\n            <polygon points=\"6.33 19.14 7.05 13.9 2.25 16.08 5.51 11.92 0.25 11.4 5.13 9.42 0.85 6.34 6.09 7.06 3.91 2.26 8.07 5.5 8.59 0.26 10.57 5.14 13.65 0.86 12.91 6.08 17.73 3.92 14.49 8.08 19.75 8.6 14.85 10.58 19.13 13.66 13.89 12.92 16.07 17.74 11.91 14.5 11.39 19.74 9.41 14.84\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sprites/icon-blast.svg
// module id = VHPH
// module chunks = 1